import fetchDataFromSpreadsheet from "./getCompanyDataFromGoogleSheets";

async function CompaniesDataArrayOfObjects() {
  const rows = await fetchDataFromSpreadsheet();

  return rows.map((row, index) => {
    return {
      companyID: index,
      companyName: row['Name']?.trim() || "",
      companysCountry: row['Country']?.trim() || "",
      sector: row['Sector']?.trim() || "",
      IRwebsiteLink: row['Website']?.trim() || "",
      symbol: row['Symbol']?.trim() || "",
      annualReportLink: row['Annual Report']?.trim() || "",
    }
  });
}

export default CompaniesDataArrayOfObjects;
